import React, { useState, useContext, useRef, useEffect } from "react";
import LessonContext from "context/lessonContext/LessonContext";
import UserContext from "context/userContext/UserContext";
import VideoPlayerSkeleton from "../skeleton/videoPlayerSkeleton";

const VideoPlayerBunnyNet = ({ videoUrl, thumbnailUrl, content }) => {
  const { updateLessonCompletionData } = useContext(LessonContext);
  const { userData } = useContext(UserContext);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isInstitutionUser, setIsInstitutionUser] = useState(false);
  const playerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  

  useEffect(() => {
    if (content) {
      updateLessonCompletionData(content);
    }
  }, [content]);

  useEffect(() => {
    if (Array.isArray(userData) && userData[0] && userData[0].is_institution_user === 1) {
      setIsInstitutionUser(true);
    } else {
      setIsInstitutionUser(false);
    }
  }, [userData]);

  useEffect(() => {
    // Set loading to false after a short delay or when resources are loaded
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500); // Adjust timing as needed
    
    return () => clearTimeout(timer);
  }, []);
  
  // Return skeleton while loading
  if (isLoading) {
    return <VideoPlayerSkeleton />;
  }

  const handlePlay = () => {
    setIsPlaying(true);
  };

 return (
    <div className="video-player-wrapper">
      <div className="bunney-net-player">
        {!isPlaying && (
          <div 
            className="react-player__preview"
            onClick={handlePlay}
          >
            <img 
              src={`https://vz-fefc3984-6fd.b-cdn.net/${thumbnailUrl}`} 
              alt="Video Thumbnail" 
              className="thumbnail" 
            />
            <button aria-label="Play">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="60"
                height="60"
              >
                <path d="M8 5v14l11-7z"/>
              </svg>
            </button>
          </div>
        )}
        {isPlaying && (
          <iframe 
            src={`https://iframe.mediadelivery.net/embed/370995/${videoUrl}?autoplay=false&loop=false&muted=${isInstitutionUser ? "true" : "false"}&preload=true&responsive=true`}
            loading="lazy"
            className="responsive-iframe"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
            allowFullScreen
            title="Video Player"
          />
        )}
      </div>
    </div>
  );
};

export default VideoPlayerBunnyNet;